module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-scrollable",
    class: {
      'hide-scroll': _vm.scrollHide, 'space-right': _vm.spaceRight, 'space-bottom': _vm.spaceBottom
    }
  }, [_c('div', {
    ref: "scrollable",
    staticClass: "scrollable",
    class: {
      'column': _vm.displayColumn
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    ref: "horizontaltrack",
    staticClass: "horizontal-track"
  }, [_c('div', {
    ref: "horizontalthumb",
    staticClass: "horizontal-thumb"
  })]), _vm._v(" "), _c('div', {
    ref: "verticaltrack",
    staticClass: "vertical-track"
  }, [_c('div', {
    ref: "verticalthumb",
    staticClass: "vertical-thumb"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1bad758"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/Scroll/Scroll.vue.html
// module id = j8fi
// module chunks = 2